import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import createAnimation from "./createAnimation";
var animationRegistry = {};
export function registerAnimation(animationName, animation) {
  animationRegistry[animationName] = animation;
}

if (typeof registerAnimation !== 'undefined' && registerAnimation && registerAnimation === Object(registerAnimation) && Object.isExtensible(registerAnimation) && !registerAnimation.hasOwnProperty('__filemeta')) {
  Object.defineProperty(registerAnimation, '__filemeta', {
    configurable: true,
    value: {
      name: "registerAnimation",
      filename: "node_modules/react-native-animatable/registry.js"
    }
  });
}

export function getAnimationByName(animationName) {
  return animationRegistry[animationName];
}

if (typeof getAnimationByName !== 'undefined' && getAnimationByName && getAnimationByName === Object(getAnimationByName) && Object.isExtensible(getAnimationByName) && !getAnimationByName.hasOwnProperty('__filemeta')) {
  Object.defineProperty(getAnimationByName, '__filemeta', {
    configurable: true,
    value: {
      name: "getAnimationByName",
      filename: "node_modules/react-native-animatable/registry.js"
    }
  });
}

export function getAnimationNames() {
  return Object.keys(animationRegistry);
}

if (typeof getAnimationNames !== 'undefined' && getAnimationNames && getAnimationNames === Object(getAnimationNames) && Object.isExtensible(getAnimationNames) && !getAnimationNames.hasOwnProperty('__filemeta')) {
  Object.defineProperty(getAnimationNames, '__filemeta', {
    configurable: true,
    value: {
      name: "getAnimationNames",
      filename: "node_modules/react-native-animatable/registry.js"
    }
  });
}

export function initializeRegistryWithDefinitions(definitions) {
  Object.keys(definitions).forEach(function (animationName) {
    registerAnimation(animationName, createAnimation(definitions[animationName]));
  });
}

if (typeof initializeRegistryWithDefinitions !== 'undefined' && initializeRegistryWithDefinitions && initializeRegistryWithDefinitions === Object(initializeRegistryWithDefinitions) && Object.isExtensible(initializeRegistryWithDefinitions) && !initializeRegistryWithDefinitions.hasOwnProperty('__filemeta')) {
  Object.defineProperty(initializeRegistryWithDefinitions, '__filemeta', {
    configurable: true,
    value: {
      name: "initializeRegistryWithDefinitions",
      filename: "node_modules/react-native-animatable/registry.js"
    }
  });
}